$(document).ready(function(){
  $(document).on('click','.variantBtn',function(e){
    e.preventDefault();
    var parthis = $(this).closest('.quantity'),  
        cur_qty = parseInt($(parthis).find('.gd-qtygd .qtyalert').attr('data-qty')),
        req_qty = parseInt($(parthis).find('.gd-qtygd .qtyalert').val());
         
    if(req_qty > cur_qty){
      $(parthis).find('.error').text('You can add only '+cur_qty+' items.');
    }else{
      $(parthis).find('.error').text('');
      $(this).text('...');
      setTimeout(function () { $(parthis).find('.variantBtn').text('Add'); }, 2000);
      $(parthis).find('.add-to-cart-gd').trigger('click');
    }
  });
});


/*====================================
  New Code for Swatch Details (Start)
=====================================*/
$(document).ready(function(){

  $('#view_available_option').click(function(){
    var sticky_nav=50;
    if($(window).width()>768){
      sticky_nav = $('.sticky_nav').outerHeight();
    }
    $('html, body').animate({
      scrollTop: $("#jump_here_gd_view_available_option").offset().top-sticky_nav
    }, 1000);
  });



  $('#option-selection li').click(function(){
    var parent = $(this),nextsib,
        widthgd = $(window).width();
    $(parent).find('.overlay-gd').addClass('active');
    var htmlgd = $(parent).find('.this-data-append').html();
    $('li.show-full-width').hide();

    if(widthgd>1024){
      if($(this).hasClass('desktop-last')){
        nextsib = $(this);
      }else{
        nextsib = $(parent).nextAll('.desktop-last:first');
      }
      if(nextsib.length == 0){
        nextsib = $('#option-selection li.last-element');
      }
      $('<li class="show-full-width">'+htmlgd+'</li>').insertAfter(nextsib).show();

    }
    if(widthgd <= 1024 && widthgd > 640 ){
      if($(this).hasClass('ipad-forth')){
        nextsib = $(this);
      }else{
        nextsib = $(parent).nextAll('.ipad-forth:first');
      }
      if(nextsib.length == 0){
        nextsib = $('#option-selection li.last-element');
      }
      $('<li class="show-full-width">'+htmlgd+'</li>').insertAfter(nextsib).show();
    }

    if(widthgd <= 640 ){
      if($(this).hasClass('mobile-odd')){
        nextsib = $(this);
      }else{
        nextsib = $(parent).nextAll('.mobile-odd:first');
      }
      if(nextsib.length == 0){
        nextsib = $('#option-selection li.last-element');
      }
      $('<li class="show-full-width">'+htmlgd+'</li>').insertAfter(nextsib).show();
    }
    $('html, body').animate({
      'scrollTop' : $(nextsib).position().top
    });

  });

  $(document).on('click','.close-gd',function(){
    $(this).closest('.show-full-width').slideUp();
  });


  $(document).on('click','.add-to-cart-gd',function(){
    $(this).html('<span>...</span>');
    var parent = $(this).closest('.quantity'),
        variant = $(this).data('variant_id'),
        qty = $(parent).find('input.quantity-box').val();
    //$.post( {'/cart/add.js', { quantity: qty,id: variant } });

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {quantity: qty,id: variant},
      success: function(data) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            $('.add-to-cart-gd').html('<span>Add</span>');
            refreshCartgd(cart);
            if($('html').hasClass("remodal-is-locked")) {
              $('.remodal-close').click();
            }

            if($('#header').is(':visible')) {
              $('#header .cart_container').addClass('active_link');
            } else if ($('.sticky_nav--stick').length) {
              $('.sticky_nav .cart_container').addClass('active_link');
            } else {
              $('.top_bar .cart_container').addClass('active_link');
            }
          }
        });
setTimeout(function(){
    if(typeof trigger_messages == 'function'){
        trigger_messages();
    }
}, 500);
      }
    });
  });
  function refreshCartgd(cart) {

    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function(index, item) {
          var line_id = index + 1;
        cart_items_html += '<li class="mini-cart__item clearfix">' +
          '<a href="' + item.url +'">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div></a>';
        }

        cart_items_html += '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' + item.url + '">' + item.title + '</a></div>';

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (value) {
              cart_items_html += '<div class="line-item">' + title +': ' + value + ' </div>';
            }
          });
        }

        cart_items_html += '<strong class="right price">';

        if (Shopify.theme_settings.display_savings){
          $.ajax({
            dataType: "json",
            async: false,
            cache: false,
            url: "/products/" + item.handle + ".js",
            success: function(data) {
              var variant_id = item.variant_id;
              var variant = $.grep(data.variants, function(v) {
                return v.id == variant_id;
              });

              if(variant[0] && variant[0].compare_at_price > item.price) {
                discounted_price_total += item.price * item.quantity;
                total_savings += variant[0].compare_at_price * item.quantity;
              }
            }
          });
        }

        if (item.price > item.final_price) {
          //puts the slash through the old item price
          var itemPrice = Shopify.formatMoney(item.final_price, $('body').data('money-format')) + ' </span><span class="money was_price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
          cart_items_html += '<span class="money sale">' + itemPrice + '</strong>';
        } else {
          var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
          cart_items_html += '<span class="money">' + itemPrice + '</span></strong>';
        }

        if (item.price > item.final_price) {
          cart_items_html += discountMessage;
        }

        cart_items_html += '<div class="left product-quantity-box">';
        cart_items_html += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cart_items_html += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id +'" value="'+ item.quantity +'" data-line-id="'+ line_id +'" />';
        cart_items_html += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cart_items_html += '</div></div></div>';
        cart_items_html += '<a href="/cart/change?line=' + line_id + '&amp;quantity=0" class="cart__remove-btn" data-line-id="' + line_id + '"><span class="remove-text">' + Shopify.translation.cart_remove_text + '</span> <span class="remove-icon"></span></a>';

      });

      cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</span></span>' +
        '<span>Subtotal</span>';

      if(total_savings > 0 ) {
        cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $cart.data('money-format')) + '</span></span>' +
          '<span>Total Savings</span>';
      } else {
        cart_savings_html = "";
      }
    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);
  }
});
/*====================================
  New Code for Swatch Details (End)
=====================================*/